<template>
  <div class="user-list">
    <el-card class="search-card">
      <el-form :model="searchForm" inline>
        <el-form-item label="姓名">
          <el-input v-model="searchForm.name" placeholder="请输入姓名" clearable />
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="searchForm.phone" placeholder="请输入手机号" clearable />
        </el-form-item>
        <el-form-item label="身份证号">
          <el-input v-model="searchForm.idCard" placeholder="请输入身份证号" clearable />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">
            <el-icon>
              <Search />
            </el-icon>查询
          </el-button>
          <el-button @click="handleReset">
            <el-icon>
              <Refresh />
            </el-icon>重置
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="table-card">
      <template #header>
        <div class="card-header">
          <span>报名人员列表</span>
          <el-button type="success" @click="handleExport">
            <el-icon>
              <Download />
            </el-icon>导出Excel
          </el-button>
        </div>
      </template>

      <!-- PC端表格 -->
      <div class="pc-view">
        <el-table v-loading="loading" :data="tableData" border stripe style="width: 100%">
          <el-table-column type="index" label="序号" width="60" align="center" />
          <el-table-column prop="name" label="姓名" min-width="100" />
          <el-table-column prop="gender" label="性别" width="80" align="center" />
          <el-table-column prop="phone" label="手机号" min-width="120" />
          <el-table-column prop="idCard" label="身份证号" min-width="180">
            <template #default="scope">
              {{ scope.row.idCard || '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="isVerified" label="核销状态" width="100" align="center">
            <template #default="scope">
              <el-tag :type="scope.row.isVerified === 1 ? 'success' : 'warning'">
                {{ scope.row.isVerified === 1 ? '已核销' : '未核销' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createdAt" label="报名时间" min-width="160">
            <template #default="scope">
              {{ formatDate(scope.row.createdAt) }}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 手机端表单形式 -->
      <div class="mobile-view">
        <div v-loading="loading" class="mobile-list">
          <div v-for="(item, index) in tableData" :key="item.id" class="mobile-item">
            <div class="mobile-item-header">
              <span class="mobile-item-index">{{ (pagination.currentPage - 1) * pagination.pageSize + index + 1
              }}</span>
              <el-tag :type="item.isVerified === 1 ? 'success' : 'warning'" size="small">
                {{ item.isVerified === 1 ? '已核销' : '未核销' }}
              </el-tag>
            </div>
            <div class="mobile-item-body">
              <div class="mobile-item-row">
                <span class="mobile-item-label">姓名：</span>
                <span class="mobile-item-value">{{ item.name || '-' }}</span>
              </div>
              <div class="mobile-item-row">
                <span class="mobile-item-label">性别：</span>
                <span class="mobile-item-value">{{ item.gender || '-' }}</span>
              </div>
              <div class="mobile-item-row">
                <span class="mobile-item-label">手机号：</span>
                <span class="mobile-item-value">{{ item.phone || '-' }}</span>
              </div>
              <div class="mobile-item-row">
                <span class="mobile-item-label">身份证号：</span>
                <span class="mobile-item-value">{{ item.idCard || '-' }}</span>
              </div>
              <div class="mobile-item-row">
                <span class="mobile-item-label">报名时间：</span>
                <span class="mobile-item-value">{{ formatDate(item.createdAt) }}</span>
              </div>
            </div>
          </div>
          <div v-if="tableData.length === 0" class="mobile-empty">
            暂无数据
          </div>
        </div>
      </div>

      <div class="pagination-container">
        <el-pagination v-model:current-page="pagination.currentPage" v-model:page-size="pagination.pageSize"
          :page-sizes="[10, 20, 50, 100]" :total="pagination.total" layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange" @current-change="handleCurrentChange" />
      </div>
    </el-card>
  </div>
</template>

<script>
import { Search, Refresh, Download } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
import axios from 'axios'
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'

export default {
  name: 'UserListPage',
  data() {
    return {
      Search,
      Refresh,
      Download,
      loading: false,
      searchForm: {
        name: '',
        phone: '',
        idCard: ''
      },
      tableData: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    // 格式化日期
    formatDate(dateStr) {
      if (!dateStr) return '-'
      const date = new Date(dateStr)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    async fetchData() {
      this.loading = true
      try {
        const params = {
          currentPage: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
          ...this.searchForm
        }

        // 移除空值
        Object.keys(params).forEach(key => {
          if (!params[key]) delete params[key]
        })

        const response = await axios.get('https://drawnew.yiyutop.cn/api/lucky/users', { params })

        if (response.data.code === 200) {
          this.tableData = response.data.data.list || []
          this.pagination.total = response.data.data.total || 0
        } else {
          ElMessage.error(response.data.msg || '获取数据失败')
        }
      } catch (error) {
        console.error('获取数据失败:', error)
        ElMessage.error('获取数据失败，请检查网络连接')
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.pagination.currentPage = 1
      this.fetchData()
    },
    handleReset() {
      this.searchForm = {
        name: '',
        phone: '',
        idCard: ''
      }
      this.pagination.currentPage = 1
      this.fetchData()
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.fetchData()
    },
    async handleExport() {
      if (this.pagination.total === 0) {
        ElMessage.warning('暂无数据可导出')
        return
      }

      this.loading = true
      ElMessage.info('正在获取全部数据，请稍候...')

      try {
        const params = {
          currentPage: 1,
          pageSize: 99999,  // 获取所有数据
          ...this.searchForm
        }

        // 移除空值
        Object.keys(params).forEach(key => {
          if (!params[key]) delete params[key]
        })

        const response = await axios.get('https://drawnew.yiyutop.cn/api/lucky/users', { params })

        if (response.data.code === 200) {
          const allData = response.data.data.list || []

          if (allData.length === 0) {
            ElMessage.warning('暂无数据可导出')
            return
          }

          // 准备导出数据
          const exportData = allData.map((item, index) => {
            return {
              '序号': index + 1,
              '姓名': item.name || '',
              '性别': item.gender || '',
              '手机号': item.phone || '',
              '身份证号': item.idCard || '-',
              '核销状态': item.isVerified === 1 ? '已核销' : '未核销',
              '报名时间': this.formatDate(item.createdAt)
            }
          })

          // 创建工作簿
          const worksheet = XLSX.utils.json_to_sheet(exportData)
          const workbook = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(workbook, worksheet, '报名人员列表')

          // 设置列宽
          const colWidths = [
            { wch: 8 },   // 序号
            { wch: 12 },  // 姓名
            { wch: 8 },   // 性别
            { wch: 15 },  // 手机号
            { wch: 20 },  // 身份证号
            { wch: 12 },  // 核销状态
            { wch: 20 }   // 报名时间
          ]
          worksheet['!cols'] = colWidths

          // 生成Excel文件
          const excelBuffer = XLSX.write(workbook, {
            bookType: 'xlsx',
            type: 'array'
          })

          // 保存文件
          const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const fileName = `报名人员列表_${new Date().toLocaleDateString()}_${allData.length}条.xlsx`
          saveAs(blob, fileName)

          ElMessage.success(`成功导出 ${allData.length} 条数据`)
        } else {
          ElMessage.error(response.data.msg || '获取数据失败')
        }
      } catch (error) {
        console.error('导出失败:', error)
        ElMessage.error('导出失败，请检查网络连接')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.user-list {
  padding: 0;
}

.search-card {
  margin-bottom: 20px;
}

.table-card {
  margin-bottom: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .pc-view {
    display: none;
  }

  .mobile-view {
    display: block;
  }

  /* 搜索表单调整 */
  .el-form--inline .el-form-item {
    margin-right: 0;
    margin-bottom: 10px;
    width: 100%;
  }

  .el-form--inline .el-form-item__content {
    width: 100%;
  }

  .el-form--inline .el-button {
    width: 100%;
    margin-top: 10px;
  }

  /* 手机端列表样式 */
  .mobile-list {
    width: 100%;
  }

  .mobile-item {
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    margin-bottom: 15px;
    overflow: hidden;
  }

  .mobile-item-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 15px;
    background: #f5f7fa;
    border-bottom: 1px solid #ebeef5;
  }

  .mobile-item-index {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
  }

  .mobile-item-body {
    padding: 15px;
  }

  .mobile-item-row {
    display: flex;
    margin-bottom: 10px;
    align-items: flex-start;
  }

  .mobile-item-label {
    width: 80px;
    font-size: 14px;
    color: #606266;
    flex-shrink: 0;
  }

  .mobile-item-value {
    flex: 1;
    font-size: 14px;
    color: #303133;
    word-break: break-all;
  }

  .mobile-empty {
    text-align: center;
    padding: 40px 0;
    color: #909399;
  }

  /* 分页调整 */
  .pagination-container {
    justify-content: center;
  }
}

@media (min-width: 769px) {
  .pc-view {
    display: block;
  }

  .mobile-view {
    display: none;
  }
}
</style>
